const pixelize = (value: number): string => `${value}px`;

export default pixelize;
